/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Step_LessonInputs */

const en_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesson`)
};

const es_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lección`)
};

const de_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfstunde`)
};

const zh_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程`)
};

const ar_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الدرس`)
};

const fr_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leçon`)
};

const vi_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buổi học`)
};

const sw_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somo`)
};

const th_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทเรียน`)
};

const bs_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekcija`)
};

const ja_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスン`)
};

const ko_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨`)
};

const pt_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aula`)
};

const it_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lezione`)
};

const sv_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektion`)
};

const nl_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les`)
};

const da_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektion`)
};

const nb_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leksjon`)
};

const fi_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppitunti`)
};

const pl_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekcja`)
};

const ru_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Урок`)
};

const tr_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ders`)
};

const hi_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ`)
};

const id_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran`)
};

const ms_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran`)
};

const cs_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekce`)
};

const el_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μάθημα`)
};

const he_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעור`)
};

const af_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les`)
};

const hu_booking_step_lesson = /** @type {(inputs: Booking_Step_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Óra`)
};

/**
* | output |
* | --- |
* | "Lesson" |
*
* @param {Booking_Step_LessonInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_step_lesson = /** @type {((inputs?: Booking_Step_LessonInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Step_LessonInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_step_lesson(inputs)
	if (locale === "de") return de_booking_step_lesson(inputs)
	if (locale === "zh") return zh_booking_step_lesson(inputs)
	if (locale === "ar") return ar_booking_step_lesson(inputs)
	if (locale === "fr") return fr_booking_step_lesson(inputs)
	if (locale === "vi") return vi_booking_step_lesson(inputs)
	if (locale === "sw") return sw_booking_step_lesson(inputs)
	if (locale === "th") return th_booking_step_lesson(inputs)
	if (locale === "bs") return bs_booking_step_lesson(inputs)
	if (locale === "ja") return ja_booking_step_lesson(inputs)
	if (locale === "ko") return ko_booking_step_lesson(inputs)
	if (locale === "pt") return pt_booking_step_lesson(inputs)
	if (locale === "it") return it_booking_step_lesson(inputs)
	if (locale === "sv") return sv_booking_step_lesson(inputs)
	if (locale === "nl") return nl_booking_step_lesson(inputs)
	if (locale === "da") return da_booking_step_lesson(inputs)
	if (locale === "nb") return nb_booking_step_lesson(inputs)
	if (locale === "fi") return fi_booking_step_lesson(inputs)
	if (locale === "pl") return pl_booking_step_lesson(inputs)
	if (locale === "ru") return ru_booking_step_lesson(inputs)
	if (locale === "tr") return tr_booking_step_lesson(inputs)
	if (locale === "hi") return hi_booking_step_lesson(inputs)
	if (locale === "id") return id_booking_step_lesson(inputs)
	if (locale === "ms") return ms_booking_step_lesson(inputs)
	if (locale === "cs") return cs_booking_step_lesson(inputs)
	if (locale === "el") return el_booking_step_lesson(inputs)
	if (locale === "he") return he_booking_step_lesson(inputs)
	if (locale === "af") return af_booking_step_lesson(inputs)
	if (locale === "hu") return hu_booking_step_lesson(inputs)
	return en_booking_step_lesson(inputs)
});